export let defaultParams = {
  file_size: 0, //图片大小 单位byte
  intended_image_size: '0*0', //业务上需要的图片大小 长 * 宽 单位px
  applied_image_size: '0*0', //实际下载到的图片大小 长 * 宽 单位px
  duration: -1, //总耗时 请求结束时间-请求开始时间（查找缓存+排队+网络+解码总时间） 单位ms
  queue_duration: -1, //排队时间，指的是业务层发起到真正开始下载等待的时间
  queue_start: -1, //排队开始时间
  queue_end: -1, //排队结束时间

  download_duration: -1, //下载总耗时 单位ms
  download_start: -1, //下载开始时间
  download_end: -1, //下载结束时间

  decode_duration: -1, //解码总耗时 单位ms
  decode_start: -1, //解码开始时间
  decode_end: -1, //解码结束时间
  render_duration: -1, // 渲染时间 ms
  render_start: -1, // 渲染开始时间 ms
  render_end: -1, // 渲染结束时间 ms

  timing_time_start: -1,
  timing_redirect_start: -1,
  timing_redirect_end: -1,
  timing_fetch_start: -1,
  timing_dns_start: -1,
  timing_dns_end: -1,
  timing_connect_start: -1,
  timing_connect_end: -1,
  timing_request_start: -1,
  timing_request_end: -1,
  timing_response_start: -1,
  timing_response_end: -1,
  timing_network_duration: -1,
  timing_connect: -1,
  timing_dns: -1,
  timing_send: -1,
  timing_wait: -1,

  timing_retry: -1, // 存在重试的情况下，重试的过程花费了多久， == 用户等待重试花费了多久
  timing_runtime: -1, // channel 脚本执行花了多久

  image_type: null, //类型，webp或者png jpg等
  image_sdk_version: "1.0.6-beta.3", //图片sdk版本号
  log_id: 783, //单次session_id内递增
  log_type: 'image_monitor_v2',
  image_count: 1, //图片的imageCount上报，如果是静图会是1，如果是动图会大于1
  load_status: 'success', //整体加载状态，指的是用户感知到的success或者fail
  fail_phase: 'download', //download或者decode等，成功的不报此字段
  err_code: 0, //错误码，如-1001等，成功的不报此字段
  err_desc: 'xxx', //错误描述，成功的不报此字段
  http_status: 0, //http状态码，正常200
  timestamp: 0, //时间戳精确到ms
  retry_count: 3, //重试的次数
  heic_custom_decoder: 0, //1: 解码时是用自研的解码器，默认：0 ver:1.0.8-alpha.
  is_bg: 0, //是否是背景图
  device_pixel_ratio: 1,
  response_sinfo: '', // cdn server ip
  response_cache: '', // cdn 用户ip
  response_cinfo: '', // cdn是否回源
  uri: null
  // "heic_sys_first": 0, //不可能感知到 1：优先使用系统的解码器，默认：0 ver:1.0.8-alpha.2

  // "reffer" : window.location.href
};
